// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  SWIPER_JS_LOADED: "fluco_section:swiper_js_loaded",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/shared/fluco-shared-countdown-timer.js
var CountdownTimer = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      section: ".fluco-section",
      sectionInner: "[js-section-inner]",
      days: "[js-days]",
      hours: "[js-hours]",
      minutes: "[js-minutes]",
      seconds: "[js-seconds]",
      timerGroup: "[js-timer-group]"
    };
  }
  connectedCallback() {
    const timerCompleted = this.getAttribute("data-timer-completed") === "true";
    if (timerCompleted === true) return;
    this.sectionEl = this.closest(this.selectors.section);
    this.sectionInnerEl = this.closest(this.selectors.sectionInner);
    this.timerGroup = this.closest(this.selectors.timerGroup);
    this.daysEl = this.querySelector(this.selectors.days);
    this.hoursEl = this.querySelector(this.selectors.hours);
    this.minutesEl = this.querySelector(this.selectors.minutes);
    this.secondsEl = this.querySelector(this.selectors.seconds);
    this.timeZoneSelection = this.dataset.timeZoneSelection;
    this.shopTimeZoneOffset = this.dataset.shopTimeZoneOffset;
    let targetYear = parseInt(this.dataset.year, 10);
    if (targetYear > 9999) {
      targetYear = 2024;
    }
    const targetMonth = parseInt(this.dataset.month, 10) - 1;
    const targetDay = parseInt(this.dataset.day, 10);
    const targetHour = parseInt(this.dataset.hour, 10);
    const targetMinute = parseInt(this.dataset.minute, 10);
    let targetMS;
    if (this.timeZoneSelection === "shop" && this.shopTimeZoneOffset) {
      const offset = this.shopTimeZoneOffset;
      const sign = offset[0] === "+" ? 1 : -1;
      const hours = parseInt(offset.slice(1, 3), 10);
      const minutes = parseInt(offset.slice(3, 5), 10);
      const offsetMinutes = sign * (hours * 60 + minutes);
      targetMS = Date.UTC(targetYear, targetMonth, targetDay, targetHour, targetMinute) - offsetMinutes * 60 * 1e3;
    } else {
      targetMS = new Date(
        targetYear,
        targetMonth,
        targetDay,
        targetHour,
        targetMinute
      );
    }
    this.targetMS = targetMS;
    this.isComplete = false;
    this.timerInterval = setInterval(this.timerLoop.bind(this), 1e3);
    this.timerLoop();
    this.timerGroup.setAttribute("data-timer-state-checked", "true");
    this.timerGroup.setAttribute("data-timer-completed", "false");
  }
  timerLoop() {
    window.requestAnimationFrame(this.updateCountdown.bind(this));
  }
  updateCountdown() {
    if (this.isComplete) return;
    const nowMS = (/* @__PURE__ */ new Date()).getTime();
    const differenceMS = this.targetMS - nowMS;
    const days = Math.floor(differenceMS / (1e3 * 60 * 60 * 24));
    const hours = Math.floor(
      differenceMS % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
    );
    const minutes = Math.floor(differenceMS % (1e3 * 60 * 60) / (1e3 * 60));
    const seconds = Math.floor(differenceMS % (1e3 * 60) / 1e3);
    if (differenceMS < 0) {
      this.timerInterval && clearInterval(this.timerInterval);
      this.daysEl.innerHTML = "0";
      this.hoursEl.innerHTML = this.minutesEl.innerHTML = this.secondsEl.innerHTML = "00";
      this.onComplete();
    } else {
      this.daysEl.innerHTML = days;
      this.hoursEl.innerHTML = `${hours}`.padStart(2, "0");
      this.minutesEl.innerHTML = `${minutes}`.padStart(2, "0");
      this.secondsEl.innerHTML = `${seconds}`.padStart(2, "0");
    }
  }
  onComplete() {
    this.setAttribute("data-timer-completed", "true");
    this.timerGroup.setAttribute("data-timer-completed", "true");
    this.isComplete = true;
    this.sectionEl.dispatchEvent(
      new Event(events_default.COUNTDOWN_TIMER_COMPLETED_EVENT)
    );
  }
  disconnectedCallback() {
    this.timerInterval && clearInterval(this.timerInterval);
    this.timerInterval = null;
  }
};
if (!customElements.get("fluco-shared-v6-countdown-timer")) {
  customElements.define("fluco-shared-v6-countdown-timer", CountdownTimer);
}
